module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (262).247c6dc6.jpg";